import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import ChartPaymentTJ from "../../components/jaklingko/chartPaymentTJ";
import ChartStationTJ from "../../components/jaklingko/chartStationTJ";
import JaklingkoTable from "../../components/jaklingko/JaklingkoTable";

const DataJaklingko = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Jaklingko"
        src="https://paques.jaktraffic.my.id/#/pdsshare/dashboard/view/shared?sid=150&standalone=true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJFeHBpcmVkIjoyMDk5ODc2NzIwLCJJZGVudGl0eSI6MTUwLCJUb2tlblR5cGUiOjB9.3XbTmM4jlfHcLUEwdvjm51hI8Ds3p9K2DpYU4zliOsM&theme=dark"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
    // <Box sx={{ px: 3 }}>
    //   {/* TITLE */}
    //   <Typography
    //     variant="h4"
    //     align="center"
    //     sx={{ fontWeight: 600, my: 4, color: "#1976d2" }}
    //   >
    //     Data Jaklingko
    //   </Typography>

    //   {/* === CHART SECTION === */}
    //   <Box
    //     sx={{
    //       display: "flex",
    //       flexDirection: "row",
    //       gap: 2,
    //       mb: 3,
    //       minWidth: 0,
    //       flexWrap: { xs: "wrap", md: "nowrap" },
    //     }}
    //   >
    //     <Box sx={{ flex: "1 1 60%", minWidth: 0, display: "flex" }}>
    //       <ChartStationTJ />
    //     </Box>

    //     <Box sx={{ flex: "1 1 40%", minWidth: 0, display: "flex" }}>
    //       <ChartPaymentTJ />
    //     </Box>
    //   </Box>

    //   {/* === TABLE === */}

    //   <Grid container spacing={3} mt={2}>
    //     <Box sx={{ width: "100%", mt: 3 }}>
    //       <JaklingkoTable />
    //     </Box>
    //   </Grid>
    // </Box>
  );
};

export default DataJaklingko;
